<template>
  <PageLayout :title="title" :prev="prevRoute" :next="true" @next="onNext">
    <ui-section title="Pixel" subtitle="Vyberte Facebook Pixel" class="mb-6">
      <ui-box>
        <v-select
          v-model="pixelId"
          hide-details="auto"
          label="Pixel"
          outlined
          :disabled="disabled"
          :items="pixels"
          item-text="name"
          item-value="id"
          @input="isValid('pixelId')"
          :error-messages="getValidationsErrors('pixelId')"
        />

        <v-select
          v-if="!!pixelId && this.isConversion"
          class="mt-4"
          label="Událost konverze"
          outlined
          hide-details="auto"
          v-model="customEventType"
          :disabled="disabled"
          :items="adsCustomEventTypes"
          item-text="name"
          item-value="key"
          @input="isValid('customEventType')"
          :error-messages="getValidationsErrors('customEventType')"
        >
          <!--          <template v-slot:append-item>-->
          <!--            <v-divider />-->
          <!--            <div class="mx-2 mt-2">-->
          <!--              <v-btn-->
          <!--                small-->
          <!--                text-->
          <!--                color="primary"-->
          <!--                @click="creatingConversion = true"-->
          <!--              >-->
          <!--                <v-icon left class="navy&#45;&#45;text text&#45;&#45;darken-1">-->
          <!--                  mdi-plus-->
          <!--                </v-icon>-->
          <!--                Vytvořit vlastní konverzi-->
          <!--              </v-btn>-->
          <!--            </div>-->
          <!--          </template>-->
        </v-select>
      </ui-box>
    </ui-section>

    <ui-section title="Výběr média" class="mb-6">
      <template #subtitle>
        Vyberte obrázek pro propagaci Vaší reklamy
        <!--        Nahrajte obrázek či video. Podle-->
        <!--        <a class="link link-underline">této studie</a> má vyšší angažovanost-->
        <!--        (engagement) na FB obrázek oproti videu-->
      </template>
      <!--      <ui-box label="Nahrajte obrázek nebo video">-->
      <ui-box label="Přidejte obrázek k reklamě">
        <div v-if="!media" class="d-flex justify-center">
          <!--          <v-btn color="primary" class="c-btn mx-2" min-width="230">-->
          <!--            Nahrát nový-->
          <!--            <v-icon right dark class="ml-4">-->
          <!--              mdi-cloud-upload-->
          <!--            </v-icon>-->
          <!--          </v-btn>-->
          <v-btn
            color="primary"
            class="c-btn mx-2"
            min-width="230"
            @click="selectingMedia = true"
          >
            Vybrat obrázek
            <v-icon right dark class="ml-4">
              mdi-plus
            </v-icon>
          </v-btn>
        </div>
        <div v-else class="d-flex align-center">
          <div
            class="rounded"
            :style="{
              backgroundImage: `url(${media.url})`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              width: '96px',
              height: '96px',
            }"
          />
          <div class="ml-4">
            <div class="body-1 font-weight-medium" v-text="media.name" />
            <div class="body-1 mb-2">
              {{ media.width }}&nbsp;×&nbsp;{{ media.height }}
            </div>
            <div>
              <v-btn small text color="red" class="ml-n2" @click="media = null">
                <v-icon left>mdi-delete-outline</v-icon>
                Smazat obrázek
              </v-btn>
            </div>
          </div>
        </div>
      </ui-box>
    </ui-section>

    <ui-section
      v-if="media"
      title="Texty a odkazy"
      subtitle="Nastavte texty a odkazy své reklamy"
      class="mb-6"
    >
      <v-row class="my-n3">
        <v-col cols="12" md="8">
          <ui-box label="Texty" class="mb-4">
            <v-textarea
              v-model="message"
              outlined
              hide-details="auto"
              label="Primární text"
              class="mb-4"
              @input="isValid('message')"
              :error-messages="getValidationsErrors('message')"
            />
            <v-text-field
              v-model="name"
              outlined
              hide-details="auto"
              label="Volitelný nadpis"
              class="mb-4"
              @input="isValid('name')"
              :error-messages="getValidationsErrors('name')"
            />
            <v-text-field
              v-model="description"
              outlined
              hide-details="auto"
              label="Volitelný popis"
              class="mb-4"
            />

            <!--            Tento blok je pro dynamic ads (asset_feed_spec), ktery zatím nefunguje-->
            <!--            <text-array-input-field-->
            <!--              v-for="(primary, index) in creative.assetFeedSpec.bodies"-->
            <!--              :key="`primary-${index}`"-->
            <!--              :can-remove="index > 0"-->
            <!--              :index="index"-->
            <!--              label="Primární text"-->
            <!--              path="creative.assetFeedSpec.bodies"-->
            <!--              :value="primary"-->
            <!--              @input="onTextUpdate"-->
            <!--              @remove="onTextRemove"-->
            <!--            ></text-array-input-field>-->

            <!--            <v-btn-->
            <!--              v-if="creative.assetFeedSpec.bodies.length < 5"-->
            <!--              text-->
            <!--              small-->
            <!--              class="primary&#45;&#45;text ml-n2 mb-4"-->
            <!--              @click="onTextAdd('creative.assetFeedSpec.bodies')"-->
            <!--            >-->
            <!--              <v-icon left small>-->
            <!--                mdi-plus-circle-outline-->
            <!--              </v-icon>-->
            <!--              Přidat další reklamní text-->
            <!--            </v-btn>-->

            <!--            <text-array-input-field-->
            <!--              v-for="(title, index) in creative.assetFeedSpec.titles"-->
            <!--              :key="`title-${index}`"-->
            <!--              :can-remove="index > 0"-->
            <!--              :index="index"-->
            <!--              label="Volitelný nadpis"-->
            <!--              path="creative.assetFeedSpec.titles"-->
            <!--              :value="title"-->
            <!--              @input="onTextUpdate"-->
            <!--              @remove="onTextRemove"-->
            <!--            ></text-array-input-field>-->

            <!--            <v-btn-->
            <!--              v-if="creative.assetFeedSpec.titles.length < 5"-->
            <!--              text-->
            <!--              small-->
            <!--              class="primary&#45;&#45;text ml-n2 mb-4"-->
            <!--              @click="onTextAdd('creative.assetFeedSpec.titles')"-->
            <!--            >-->
            <!--              <v-icon left small>-->
            <!--                mdi-plus-circle-outline-->
            <!--              </v-icon>-->
            <!--              Přidat další nadpis-->
            <!--            </v-btn>-->

            <!--            <text-array-input-field-->
            <!--              v-for="(description, index) in creative.assetFeedSpec-->
            <!--                .descriptions"-->
            <!--              :key="`description-${index}`"-->
            <!--              :can-remove="index > 0"-->
            <!--              :index="index"-->
            <!--              label="Volitelný popis"-->
            <!--              path="creative.assetFeedSpec.descriptions"-->
            <!--              :value="description"-->
            <!--              @input="onTextUpdate"-->
            <!--              @remove="onTextRemove"-->
            <!--            ></text-array-input-field>-->

            <!--            <v-btn-->
            <!--              v-if="creative.assetFeedSpec.descriptions.length < 5"-->
            <!--              text-->
            <!--              small-->
            <!--              class="primary&#45;&#45;text ml-n2 mb-4"-->
            <!--              @click="onTextAdd('creative.assetFeedSpec.descriptions')"-->
            <!--            >-->
            <!--              <v-icon left small>-->
            <!--                mdi-plus-circle-outline-->
            <!--              </v-icon>-->
            <!--              Přidat další popis-->
            <!--            </v-btn>-->
          </ui-box>

          <ui-box label="Odkaz" class="mb-4">
            <v-text-field
              v-model="link"
              outlined
              hide-details="auto"
              label="URL adresa webové stránky"
              class="mb-4"
              @input="isValid('link')"
              :error-messages="getValidationsErrors('link')"
            />
            <v-text-field
              v-model="caption"
              outlined
              hide-details="auto"
              label="Odkaz pro zobrazení"
              class="mb-4"
            />
            <v-select
              v-model="callToActionType"
              outlined
              hide-details="auto"
              label="Výzva k akci"
              class="mb-4"
              :items="adsCallToActionTypes"
              item-text="name"
              item-value="key"
              @input="isValid('callToActionType')"
              :error-messages="getValidationsErrors('callToActionType')"
            />
          </ui-box>
        </v-col>

        <v-col cols="12" md="4">
          <AdPreview :store-namespace="storeNamespace" />
        </v-col>
      </v-row>
    </ui-section>

    <!--    <v-dialog scrollable v-model="creatingConversion" max-width="1000px">-->
    <!--      <v-card>-->
    <!--        <v-card-title>-->
    <!--          <v-container>-->
    <!--            <div class="display-1 font-weight-bold">-->
    <!--              Vlastní konverze-->
    <!--            </div>-->
    <!--          </v-container>-->
    <!--        </v-card-title>-->
    <!--        <v-card-text>-->
    <!--          <v-container>-->
    <!--            <v-row class="mb-6">-->
    <!--              <v-col cols="12" md="6">-->
    <!--                <v-text-field-->
    <!--                  label="Potenciální zákazník"-->
    <!--                  outlined-->
    <!--                  :counter="50"-->
    <!--                />-->
    <!--              </v-col>-->
    <!--              <v-col cols="12" md="6">-->
    <!--                <v-text-field-->
    <!--                  label="Popis (volitelné)"-->
    <!--                  outlined-->
    <!--                  :counter="100"-->
    <!--                />-->
    <!--              </v-col>-->
    <!--              <v-col cols="12">-->
    <!--                <v-select label="Zdroj dat" outlined hide-details />-->
    <!--              </v-col>-->
    <!--              <v-col cols="12">-->
    <!--                <v-select label="Konverzní událost" outlined hide-details />-->
    <!--              </v-col>-->
    <!--              <v-col cols="12">-->
    <!--                <v-select-->
    <!--                  label="Standardní událost pro optimalizaci"-->
    <!--                  outlined-->
    <!--                  hide-details-->
    <!--                />-->
    <!--              </v-col>-->
    <!--            </v-row>-->
    <!--            <ui-box-label>-->
    <!--              Pravidla-->
    <!--            </ui-box-label>-->
    <!--            <div class="body-1 mb-2">-->
    <!--              Tato vlastní konverze musí splňovat všechna tato pravidla:-->
    <!--            </div>-->
    <!--            <v-card outlined class="px-2 py-4 mb-2">-->
    <!--              <v-row no-gutters>-->
    <!--                <v-col cols="6" md="3">-->
    <!--                  <v-select-->
    <!--                    class="mx-2"-->
    <!--                    outlined-->
    <!--                    hide-details-->
    <!--                    value="url"-->
    <!--                    label="Vlastnost"-->
    <!--                    :items="[{ text: 'URL', value: 'url' }]"-->
    <!--                  />-->
    <!--                </v-col>-->
    <!--                <v-col cols="6" md="3">-->
    <!--                  <v-select-->
    <!--                    class="mx-2"-->
    <!--                    outlined-->
    <!--                    hide-details-->
    <!--                    value="contains"-->
    <!--                    label="Podmínka"-->
    <!--                    :items="[{ text: 'Obsahuje', value: 'contains' }]"-->
    <!--                  />-->
    <!--                </v-col>-->
    <!--                <v-col cols="12" md="6">-->
    <!--                  <v-text-field-->
    <!--                    class="mx-2"-->
    <!--                    outlined-->
    <!--                    hide-details-->
    <!--                    label="Hodnota"-->
    <!--                    placeholder="Klíčová slova v URL"-->
    <!--                  />-->
    <!--                </v-col>-->
    <!--              </v-row>-->
    <!--            </v-card>-->
    <!--            <v-btn text small class="primary&#45;&#45;text ml-n2">-->
    <!--              <v-icon left small>-->
    <!--                mdi-plus-circle-outline-->
    <!--              </v-icon>-->
    <!--              Přidat další pravidlo-->
    <!--            </v-btn>-->
    <!--            <v-checkbox label="Zadejte hodnotu konverze" />-->
    <!--          </v-container>-->
    <!--        </v-card-text>-->
    <!--        <v-divider></v-divider>-->
    <!--        <v-card-actions class="c-dialog__footer">-->
    <!--          <v-container class="d-flex justify-space-between px-6">-->
    <!--            <v-btn text @click="creatingConversion = false">-->
    <!--              Zavřít-->
    <!--            </v-btn>-->
    <!--            <v-btn-->
    <!--              color="primary"-->
    <!--              class="c-btn"-->
    <!--              @click="creatingConversion = false"-->
    <!--            >-->
    <!--              Přidat-->
    <!--            </v-btn>-->
    <!--          </v-container>-->
    <!--        </v-card-actions>-->
    <!--      </v-card>-->
    <!--    </v-dialog>-->

    <ui-media-library-dialog
      :media="media"
      :opened.sync="selectingMedia"
      :selected.sync="selectedMediaTemp"
      @confirm="media = selectedMediaTemp"
    />
  </PageLayout>
</template>

<script>
import { call, get, sync } from "vuex-pathify"

import PageLayout from "@/components/page/ads/edit/PageLayout.vue"
// import TextArrayInputField from "@/components/ui/TextArrayInputField"
import AdPreview from "@/components/page/ads/AdPreview.vue"
import validation from "@/mixins/validation"
import { required, url } from "vuelidate/lib/validators"

export default {
  name: "AdDesignWeb",
  components: {
    PageLayout,
    // TextArrayInputField,
    AdPreview,
  },
  mixins: [validation],
  props: {
    id: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    nextRoute: {
      type: String,
      default: null,
    },
    prevRoute: {
      type: String,
      default: null,
    },
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedMediaTemp: null,
      selectingMedia: false,
      validationMessages: {
        pixelId: {
          required: "Toto pole je povinné",
        },
        customEventType: {
          required: "Toto pole je povinné",
        },
        message: {
          required: "Toto pole je povinné",
        },
        name: {
          required: "Toto pole je povinné",
        },
        link: {
          required: "Toto pole je povinné",
          url:
            "Pole musí být plátná URL adresa ve formátu http://vasweb.cz nebo https://vasweb.cz",
        },
        callToActionType: {
          required: "Toto pole je povinné",
        },
      },
    }
  },
  validations: {
    pixelId: {
      required,
    },
    customEventType: {
      function(customEventType) {
        return customEventType || !this.isConversion
      },
    },
    message: {
      required,
    },
    name: {
      required,
    },
    link: {
      required,
      url,
    },
    callToActionType: {
      required,
    },
  },
  computed: {
    ...get("enumerations", ["adsCallToActionTypes", "adsCustomEventTypes"]),
    ...get("pixels", ["pixels"]),
    title() {
      return this.isConversion ? "Konverze" : "Návštěvnost"
    },
    isConversion() {
      return this.objective === "CONVERSIONS"
    },
  },
  methods: {
    ...call("pixels", ["loadPixels"]),
    onTextAdd(path) {
      this.modelTextArrayAppend(path)
    },
    onTextUpdate(value, path, index) {
      this.modelTextArrayUpdate({ value, path, index })
    },
    onTextRemove(path, index) {
      this.modelTextArrayRemove({ path, index })
    },
    onNext() {
      if (this.isValidAll() && this.media) {
        this.$router.push(this.nextRoute)
      }
    },
  },
  mounted() {
    this.loadPixels()
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    if (!this.$options.computed) {
      this.$options.computed = {}
    }
    if (!this.$options.methods) {
      this.$options.methods = {}
    }

    Object.assign(this.$options.computed, {
      ...get(`${storeNamespace}/model@campaign`, ["objective"]),
      ...sync(`${storeNamespace}/model@`, ["creative", "media"]),
      ...sync(`${storeNamespace}/model@adset.promotedObject`, [
        "customEventType",
        "pixelId",
      ]),
      ...sync(`${storeNamespace}/model@creative`, ["callToActionType"]),
      ...sync(`${storeNamespace}/model@creative.objectStorySpec`, [
        "caption",
        "link",
        "message",
        "name",
        "description",
      ]),
    })

    Object.assign(this.$options.methods, {
      ...call(`${storeNamespace}`, [
        "modelTextArrayAppend",
        "modelTextArrayRemove",
        "modelTextArrayUpdate",
      ]),
    })
  },
}
</script>
